export const DETAIL_LIST = {
  driver_abstract_documentation_requested: {
    translationPrefix:
      'components.Report.Verification.MatrixVerification.driver_abstract_documentation_requested',
  },
  mvr_consent: {
    translationPrefix:
      'components.Report.Verification.MatrixVerification.mvr_consent_download_upload',
  },
  dl_documentation_requested: {
    translationPrefix:
      'components.Report.Verification.MatrixVerification.dl_documentation_requested_mvr',
  },
};

export const JURISDICTIONS_MAPPING: Record<string, string> = {
  AB: 'Alberta',
  BC: 'British Columbia',
  MB: 'Manitoba',
  NB: 'New Brunswick',
  NL: 'Newfoundland and Labrador',
  NS: 'Nova Scotia',
  NT: 'Northwest Territories',
  NU: 'Nunavut',
  ON: 'Ontario',
  PE: 'Prince Edward Island',
  PR: 'Puerto Rico',
  QC: 'Quebec',
  SK: 'Saskatchewan',
  VI: 'U.S. Virgin Islands',
  YT: 'Yukon',
};

export const MVR_CONSENT_FORMS_BASE_URL =
  'https://us-east-1-checkr.s3.us-east-1.amazonaws.com/resources/mvr-consent-forms/';

export function getConsentFormUriForJurisdiction(
  jurisdiction: string | undefined,
): string | undefined {
  if (!jurisdiction) return undefined;
  return `${MVR_CONSENT_FORMS_BASE_URL}${jurisdiction.toLowerCase()}_consent.pdf`;
}
